/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const BaseCommentBaseParser = /* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['workId', codecNumber, 'work_id'],
]);
export class BaseCommentBase extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseCommentBaseParser.decode(input).map(res => new BaseCommentBase(res));
    }
    static unsafeDecode(input) {
        return BaseCommentBase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseCommentBaseParser.encode(data);
    }
    static schema() {
        return BaseCommentBaseParser.schema();
    }
}
